import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as benchmarksMain from '../reducers';
import * as benchmarksMainSub from '../reducers/get-benchmarks.reducer';

export const getBenchmarksRequest = createSelector(benchmarksMain.selectGetBenchmarksState, benchmarksMainSub.selectBenchmarks);

export const getBenchmarksLoaded = createSelector(benchmarksMain.selectGetBenchmarksState, benchmarksMainSub.selectBenchmarksLoaded);

export const getBenchmarksFailure = createSelector(benchmarksMain.selectGetBenchmarksState, benchmarksMainSub.selectBenchmarksError);
